(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  var wishlistButton = document.querySelector(".wishlist-btn");
  var wishlistButtonAnchor = document.querySelector(".wishlist-btn__anchor");
  
  function swymCallbackFn(){    
      if(wishlistButton){
          _swat.fetchWrtEventTypeET(fetchCallbackFn, 4);       
          // fetching all wishlist events
      }
  }

  function fetchCallbackFn(products){
  var activeProductId = SwymPageData.empi, 
      activeVariantId = SwymPageData.epi;
  var isInWishlist = products.find(function(p){
      return p.empi == activeProductId && p.epi == activeVariantId;
  });

  if(isInWishlist){
      wishlistButtonAnchor.setAttribute("disabled", true);
      wishlistButtonAnchor.innerHTML = theme.strings.apps_wishlist_pdp_added;
  } else {
      wishlistButtonAnchor.addEventListener("click", function(e){
      if(SwymPageData){
          SwymPageData.et = 4;	// et 4 stands for wishlist event type
          _swat.addToWishList(SwymPageData, function(e){
            wishlistButtonAnchor.setAttribute("disabled", true);
            wishlistButtonAnchor.innerHTML = theme.strings.apps_wishlist_pdp_added;
          });
      }
      });
  }
  }
  if(!window.SwymCallbacks){
      window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);

  } catch(e) { console.error(e); }
})();

})();
